import { isNaN } from "lodash";
import { batch } from "react-redux";

import { setRunningMethod } from "@/actions/autoProfileStateAction";
import {
  resetScheduler,
  setScheduleWillRun,
} from "@/actions/schedulerStateAction";
import {
  SetCycleFinishStatus,
  isFinishRecovery,
  modifyProfile,
  pauseProteinConcentrator,
  runProteinConcentrator,
  setCleaningProperties,
  topButtonTertiaryProperties,
  updateLockAccess,
  updatePCState,
  updatePercentageProgressBar,
  updateProgressBarStatus,
  updateRecoveryStatus,
  updateStatus,
  showAlert,
  SetErrorParams,
  updateEstimateTime,
  updateStoppingFromButton,
  SetCustomOperationStatus,
  UpdateTempOperationList,
  UpdateOperationList,
  SetCustomOperationRepeatValue,
  SetCustomOperationRepeatedValue,
  SetDefaultPrimeParam,
  SetCustomOperationMessage,
  updateIsManualProfileRunning,
  SetCleaningCustomOperationStatus,
  UpdateCleaningOperationList,
  SetCleaningCustomOperationName,
  SetCleaningCustomOperationDepressurizingAtTheEnd,
  SetCleaningCustomOperationRepeatValue,
  SetCleaningCustomOperationRepeatedValue,
  SetCleaningDefaultPrimeParam,
  SetCleaningCustomOperationMessage,
  SetCleaningCustomOperationTimeElapsed,
  updateShowThresholdError,
  IsRecoveryFromErrorProfile,
  updateCurrentIsMoreThan50ml,
  updateAutoProfileSetupMode,
  updateCurrentAdvSetupParam,
} from "@/actions/setupActions";
import { setDeviceHubConnectionState } from "@/actions/signalrStateAction";
import { getSelectedAdvSetupsApi } from "@/api/advSetupApi";
import { getStatus } from "@/api/deviceApi";
import { PostRequest } from "@/api/request";
import {
  AutoProfileConstants,
  RecoveryOfLiquidAction,
  StopEnum,
} from "@/constants/autoProfileEnum";
import { VOLUME_SENSOR } from "@/constants/configurations";
import {
  AutoProfileOperationMode,
  AutoProfileOperationModeMethod,
  DeviceFailureError,
} from "@/constants/dataEnum";
import { ALERT_TYPE } from "@/constants/enums";
import { PRESSURE_RUN_TOO_LONG_MESSAGE } from "@/constants/messages";
import * as APPDATA from "@/constants/pcConstAppData";
import {
  EventLicenseService,
  LockStatusPageEvent,
  RecoveryOfLiquidEvent,
} from "@/constants/pubSubEnum";
import { MANUAL_CONTROL_ENUM } from "@/constants/statusManualControlEnum";
import { isEqual, GetPathOfPage } from "@/libs/appHelper";
import {
  getAutoProfileModeOnRunningProfile,
  getAutoProfileUpdateStatusModel,
} from "@/libs/autoProfileHelper";
import { consoleDebug, consoleLog } from "@/libs/consoleHelper";
import { formatMessage } from "@/libs/intlHelper";
import { goToAutoSetupScreen } from "@/libs/navigationHelper";
import { enumToCamelCase } from "@/libs/stringHelper";
import { eventBusObject } from "@/observers/eventBus";

import { ConvertBEOperationsToUIOperations } from "../../contents/manualProfile/business/statusContent";
import * as deviceInfoActions from "../actions/deviceInfoActions";
import {
  isShowRecoveryLoading,
  showLoading,
  updateLoading,
} from "../actions/loadingActions";
import {
  setStartManualControl,
  updateManualControlState,
  setStatusManualControl,
} from "../actions/manualControlActions";
import * as manualControlActions from "../actions/manualControlActions";
import { hideModal, hidePopUp, showPopUp } from "../actions/modalActions";
import { INITIAL_STATUS_MANUAL_CONTROL } from "../reducers/manualControlStore";
import { initialState } from "../reducers/setupStore";

import {
  hideScheduleRunModal,
  postHighVolumeBuffer,
  showPauseToRefillModal,
  validateAutoProfileScheduledParams,
} from "./autoProfileBusiness";
// import { PostStopRecovery } from "./fetchManualControl";
import { PostStopRecovery } from "./fetchManualControl";
import { handleRefillBufferVolumeOnEvent } from "./refillBufferVolBusiness";

/**
 * setup the state when DEVICE_STATE.PAUSED state occurs
 */
const pauseActionHandler = (operationMode) => (dispatch, getState) => {
  const { autoProfileState } = { ...getState() };
  const { isPauseHandled } = autoProfileState;
  const isShowPauseToRefill =
    AutoProfileOperationMode.BUFFER_EXCHANGE === operationMode &&
    isPauseHandled;

  batch(() => {
    if (isShowPauseToRefill) dispatch(showPauseToRefillModal());
    dispatch(updatePCState(APPDATA.DEVICE_STATE.PAUSED));
    dispatch(pauseProteinConcentrator({ isPCPaused: true }));
    dispatch(showLoading(false));
  });
};

/**
 * displaying depressurizing modal dialog
 */
const ShowDepressurizingLoading = () => (dispatch, getState) => {
  batch(() => {
    const { modalStore } = getState();
    if (modalStore.popUpTitle !== APPDATA.MESSAGES.PROFILE.STOP_PROFILE.TITLE) {
      dispatch(hidePopUp());
    }
    dispatch(updatePCState(APPDATA.DEVICE_STATE.DEPRESSURIZING));
    dispatch(
      updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.CYCLE_PROCESS.DEPRESSURIZING,
        // loadingButton1: {
        //     label: APPDATA.CLOSE,
        //     onClick: () => dispatch(showLoading(false)),
        // },
      })
    );
  });
};

/**
 * displaying recovering modal dialog
 */
const ShowRecoveringLoading = () => (dispatch, getState) => {
  const { setupStore } = getState();
  const { recoveryOfLiquidStatus, errorParams, status } = setupStore;
  const { CurrentRecoveryStatus, CycleCount, NumberOfCycle } =
    recoveryOfLiquidStatus;
  const recoveryPercentage = (
    (Number(CycleCount) / Number(NumberOfCycle)) *
    100
  ).toFixed(VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY);
  consoleLog(
    "ShowRecoveringLoading",
    recoveryOfLiquidStatus,
    errorParams,
    CurrentRecoveryStatus,
    CycleCount,
    NumberOfCycle,
    recoveryPercentage,
    status
  );
  batch(() => {
    dispatch(updatePCState(APPDATA.DEVICE_STATE.RECOVERING));
    if (errorParams === null) {
      dispatch(hidePopUp());
      dispatch(
        updateLoading({
          showLoading: true,
          loadingText: "",
        })
      );
    } else {
      // PostRequest(POST_STOP_PROTEIN_CONCENTRATOR, { StopAction: StopEnum.NONE });
    }
  });
};

/**
 * displaying failure message
 * @param {Boolean} isOperationCompleted
 * @param {String} message
 */
const DisplayingFailureMessage =
  (isOperationCompleted, message) => (dispatch, getState) => {
    const {
      manualControlStore: {
        IsShowManualControlAvailablePopUp,
        IsShowManualControlPopUp,
      },
    } = getState();
    if (message) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText: message,
          alertStyle: isOperationCompleted
            ? ALERT_TYPE.ALERT_SUCCESS
            : ALERT_TYPE.ALERT_DANGER,
        })
      );

      if (
        message === PRESSURE_RUN_TOO_LONG_MESSAGE &&
        IsShowManualControlAvailablePopUp &&
        IsShowManualControlPopUp
      ) {
        dispatch(manualControlActions.IsShowManualControlPopUp(false));
        dispatch(manualControlActions.IsShowManualControlAvailablePopUp(false));
      }
    }
  };
/**
 * currentPCState === DEVICE_STATE.IDLE and the onStateChange event invoked
 */
const OnIdleStateChangeHandler = (deviceState) => (dispatch) => {
  if (deviceState === APPDATA.DEVICE_STATE.PREPARING) {
    consoleLog("OnIdleStateChangeHandler", deviceState);
    // eslint-disable-next-line new-cap
    const bus = eventBusObject();
    batch(() => {
      dispatch(runProteinConcentrator({ isPCRunning: true }));
      dispatch(modifyProfile(false)); // disable edit/delete running profile
      dispatch(pauseProteinConcentrator({ isPCPaused: false })); // if pause when stopping status, reset isPCPaused
      dispatch(updatePercentageProgressBar(0)); // reset progressbar
      dispatch(updateProgressBarStatus(APPDATA.CSS_NOT_STARTED)); // reset progressbar

      bus.publish(LockStatusPageEvent.ON_CLICK_LOCK_CONCENTRATOR, {
        isLockAccess: false,
        isDisabled: false,
      });
      bus.publish(EventLicenseService.TrialLicenseDayLeftInfoService, {});
    });
    dispatch(updatePCState(APPDATA.DEVICE_STATE.PREPARING));
    window.location.href = APPDATA.AUTO_PROFILE_STATUS;
  } else {
    dispatch(updatePCState(deviceState));
  }
  dispatch(closeLockRunningProfileModal());
};

const closeLockRunningProfileModal = () => (dispatch, getState) => {
  const { modalStore } = { ...getState() };
  const { modalVisible, modalHeader, modalTitle } = modalStore;
  if (
    ([APPDATA.LOCK_ACCESS, APPDATA.UNLOCK_ACCESS].includes(modalHeader) ||
      [APPDATA.LOCK_ACCESS, APPDATA.UNLOCK_ACCESS].includes(modalTitle)) &&
    modalVisible
  )
    dispatch(hideModal());
};

/**
 * currentPCState === DEVICE_STATE.PAUSED and the onStateChange event invoked
 */
const OnPauseStateChangeHandler = (deviceState) => (dispatch) => {
  switch (deviceState) {
    case APPDATA.DEVICE_STATE.CONCENTRATING:
    case APPDATA.DEVICE_STATE.STOPPING:
    case APPDATA.DEVICE_STATE.DIAFILTRATION:
    case APPDATA.DEVICE_STATE.PREPARING:
    case APPDATA.DEVICE_STATE.PRIMING:
      batch(() => {
        dispatch(updatePCState(deviceState));
        dispatch(pauseProteinConcentrator({ isPCPaused: false }));
      });
      break;
    case APPDATA.DEVICE_STATE.IDLE:
      dispatch(updatePCState(APPDATA.DEVICE_STATE.STOPPING));
      dispatch(OnStopppingStateChangeHandler(APPDATA.DEVICE_STATE.IDLE));
      dispatch(closeLockRunningProfileModal());
      break;
    case APPDATA.DEVICE_STATE.RECOVERING:
      dispatch(ShowRecoveringLoading());
      break;
    default:
      dispatch(updatePCState(deviceState));
      break;
  }
};

/**
 * currentPCState === DEVICE_STATE.RECOVERING and the onStateChange event invoked
 */
const OnRecoveringStateChangeHandler = (deviceState) => (dispatch) => {
  switch (deviceState) {
    case APPDATA.DEVICE_STATE.DEPRESSURIZING:
      dispatch(ShowDepressurizingLoading());
      break;
    case APPDATA.DEVICE_STATE.RECOVERING:
      // ShowDepressurizingLoading();
      break;
    default:
      dispatch(updatePCState(deviceState));
      break;
  }
};

/**
 * currentPCState === DEVICE_STATE.DEPRESSURIZING and the onStateChange event invoked
 */
const OnDepressurizingStateChangeHandler =
  (deviceState, operationMode) => (dispatch) => {
    const bus = eventBusObject();

    switch (deviceState) {
      case APPDATA.DEVICE_STATE.IDLE:
        batch(() => {
          dispatch(updatePCState(APPDATA.DEVICE_STATE.STOPPING));
          dispatch(OnStopppingStateChangeHandler(APPDATA.DEVICE_STATE.IDLE));
          dispatch(closeLockRunningProfileModal());
          dispatch(
            manualControlActions.IsShowManualControlAvailablePopUp(false)
          );
          dispatch(manualControlActions.IsShowManualControlPopUp(false));
        });

        bus.publish(RecoveryOfLiquidEvent.HIDE_POP_UP);
        break;
      case APPDATA.DEVICE_STATE.PAUSED:
        dispatch(pauseActionHandler(operationMode));
        break;
      case APPDATA.DEVICE_STATE.RECOVERING:
        dispatch(ShowRecoveringLoading());
        break;
      default:
        dispatch(updatePCState(deviceState));
        break;
    }
  };

/**
 * currentPCState === DEVICE_STATE.STOPPING and the onStateChange event invoked
 */
const OnStopppingStateChangeHandler = (deviceState) => async (dispatch) => {
  const eventBus = eventBusObject();
  const isRemoteView = false; // const { isRemoteView } = props;
  switch (deviceState) {
    case APPDATA.DEVICE_STATE.IDLE: {
      const newStatus = getAutoProfileUpdateStatusModel(initialState);

      batch(() => {
        dispatch(updatePCState(deviceState));
        dispatch(showLoading(false));
        dispatch(isFinishRecovery(false));
        dispatch(runProteinConcentrator({ isPCRunning: false }));
        dispatch(pauseProteinConcentrator({ isPCPaused: false }));
        dispatch(modifyProfile(true));
        dispatch(updateLockAccess(false));
        dispatch(updatePercentageProgressBar(0));
        dispatch(updateStatus(newStatus));
        dispatch(setStartManualControl(INITIAL_STATUS_MANUAL_CONTROL));
        dispatch(
          updateManualControlState(
            MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL
          )
        );
      });

      const { data } = await getStatus();
      const { isCycleFinish, failureMessage } = data;

      batch(() => {
        dispatch(DisplayingFailureMessage(isCycleFinish, failureMessage));

        dispatch(topButtonTertiaryProperties(undefined));
        dispatch(closeLockRunningProfileModal());
      });

      eventBus.publish(LockStatusPageEvent.ON_CLICK_LOCK_CONCENTRATOR, {
        isLockAccess: false,
        isDisabled: true,
      });

      if (!isRemoteView) window.location.href = APPDATA.AUTO_PROFILE_SETUP;
      break;
    }
    default:
      dispatch(updatePCState(deviceState));
      break;
  }
};

const handleRecoveryStatusUpdate =
  (recoveryOfLiquidStatus) => (dispatch, getState) => {
    const {
      setupStore: {
        currentPCState,
        isPCRunning,
        isManualProfileRunning,
        cleaningProperties,
        isFromStopProfile,
      },
      loadingStore,
      modalStore,
    } = getState();
    const IsPCRunning =
      isPCRunning ||
      isManualProfileRunning ||
      cleaningProperties.isCleaningWizardRunning;

    if (
      recoveryOfLiquidStatus !== null &&
      IsPCRunning &&
      currentPCState === APPDATA.DEVICE_STATE.RECOVERING
    ) {
      consoleLog(
        "useEffect recoveryOfLiquidStatus",
        currentPCState,
        recoveryOfLiquidStatus,
        IsPCRunning,
        loadingStore.showLoading
      );
      if (recoveryOfLiquidStatus.CurrentRecoveryStatus !== "None") {
        const { popUpVisible } = modalStore;

        if (recoveryOfLiquidStatus.IsComplete === "False") {
          if (loadingStore.showLoading) {
            batch(() => {
              dispatch(hidePopUp());
              dispatch(isFinishRecovery(false));
              if (loadingStore.isShowRecoveryLoading)
                dispatch(isShowRecoveryLoading(true));
              if (loadingStore.showLoading) dispatch(showLoading(true));

              if (recoveryOfLiquidStatus.IsStopping === "False") {
                dispatch(
                  updateLoading({
                    showLoading: true,
                    loadingButton1: {
                      label: formatMessage({
                        id: "general.button.label.cancel",
                      }),
                      onClick: async () => {
                        await dispatch(PostStopRecovery());
                      },
                    },
                    loadingText:
                      APPDATA.MESSAGES.CYCLE_PROCESS.RECOVERY_THE_LIQUID_WITH_PROGRESS.replace(
                        "{CURRENT_RECOVERY}",
                        recoveryOfLiquidStatus.CurrentRecoveryStatus
                      ).replace(
                        "{...}",
                        (
                          (Number(recoveryOfLiquidStatus.CycleCount) /
                            Number(recoveryOfLiquidStatus.NumberOfCycle)) *
                          100
                        ).toFixed(
                          APPDATA.CONFIGURATION.VOLUME_SENSOR
                            .DECIMAL_PLACE_ACCURACY
                        )
                      ),
                  })
                );
              } else if (recoveryOfLiquidStatus.IsStopping === "True") {
                dispatch(
                  updateLoading({
                    showLoading: true,
                    loadingText: "Cancelling...",
                    loadingButton1: {
                      label: formatMessage({
                        id: "general.button.label.cancel",
                      }),
                      disabled: true,
                    },
                  })
                );
              }
            });
          }
        }

        if (!popUpVisible && recoveryOfLiquidStatus.IsComplete === "True") {
          batch(() => {
            dispatch(updateStoppingFromButton(true));
            if (loadingStore.isShowRecoveryLoading)
              dispatch(isShowRecoveryLoading(false));
            if (loadingStore.showLoading) dispatch(showLoading(false));
            dispatch(isFinishRecovery(true));
          });
          const bus = eventBusObject();
          bus.publish(RecoveryOfLiquidEvent.SHOW_POP_UP, {
            recoveryAction: isFromStopProfile
              ? RecoveryOfLiquidAction.RECOVERY_FROM_STOP_POPUP
              : RecoveryOfLiquidAction.RECOVERY_FROM_STOP_AUTO,
          });
        }
      }
    }
  };

const setEstimateTime = (secondsElapsed) => (dispatch, getState) => {
  const {
    setupStore: { estimateTime },
  } = getState();
  let timeHHMMSS = secondsElapsed;
  if (!Number.isNaN(parseInt(secondsElapsed, 10))) {
    let second = parseInt(secondsElapsed, 10);
    let hour = parseInt(second / 3600, 10);
    second %= 3600;
    let minute = parseInt(second / 60, 10);
    second %= 60;
    hour = isNaN(hour) ? "0" : hour.toString();
    minute = isNaN(minute) ? "0" : minute.toString();
    second = isNaN(second) ? "0" : second.toString();
    const timeString = `${hour}:${minute.padStart(2, "0")}:${second.padStart(
      2,
      "0"
    )}`;
    timeHHMMSS = timeString;
  }
  if (timeHHMMSS !== estimateTime) dispatch(updateEstimateTime(timeHHMMSS));
};

const GetPCLocked = (isPCLock) => (dispatch, getState) => {
  const {
    setupStore: { lockAccess, isPCRunning },
  } = getState();
  if (isPCLock !== lockAccess) {
    const bus = eventBusObject();
    bus.publish(LockStatusPageEvent.ON_CLICK_LOCK_CONCENTRATOR, {
      isLockAccess: isPCLock,
      isDisabled: !isPCRunning,
    });
    dispatch(updateLockAccess(isPCLock));
  }
};

const checkIsManualControlEnable =
  (newStatusOfManualControl, previouseStatusManualControl) =>
  (dispatch, getState) => {
    const { setupStore, manualControlStore } = getState();
    const { isPCRunning, profileRunning } = setupStore;
    const { IsShowManualControlAvailablePopUp } = manualControlStore;
    const { SafetyThreshold, TargetVolume, MinimumVolume } =
      newStatusOfManualControl;

    const targetVolume = Math.floor(TargetVolume * 100) / 100;
    const FinalVolume = Number(profileRunning.Config.FinalVolume);
    const manualControlThreshold = Number(SafetyThreshold);
    const minManualControlThreshold = Number(
      MinimumVolume ||
        AutoProfileConstants.SAFETY_THRESHOLD_POP_UP_VALUE_ZERO + 1
    );

    if (!isPCRunning) return;

    if (
      previouseStatusManualControl.IsManualControlEnable ===
        APPDATA.ENUM.MANUAL_CONTROL_STATE.DISABLE &&
      newStatusOfManualControl.IsManualControlEnable ===
        APPDATA.ENUM.MANUAL_CONTROL_STATE.ENABLE
    ) {
      dispatch(showLoading(false));

      if (IsShowManualControlAvailablePopUp) {
        if (
          FinalVolume < AutoProfileConstants.FINAL_VOLUME_POP_UP_VALUE_THREE
        ) {
          batch(() => {
            dispatch(manualControlActions.updateVolumeInMl(targetVolume));
            dispatch(manualControlActions.IsShowManualControlPopUp(true));
          });
        }
      } else if (
        FinalVolume < AutoProfileConstants.FINAL_VOLUME_POP_UP_VALUE_THREE &&
        manualControlThreshold >= minManualControlThreshold
      ) {
        const activePageAddress = GetPathOfPage(window.location.href);

        if (activePageAddress !== APPDATA.AUTO_PROFILE_STATUS)
          window.location.href = APPDATA.AUTO_PROFILE_STATUS;

        batch(() => {
          dispatch(manualControlActions.updateVolumeInMl(targetVolume));
          dispatch(
            manualControlActions.IsShowManualControlAvailablePopUp(true)
          );
          dispatch(manualControlActions.IsShowManualControlPopUp(true));
        });
      } else if (
        targetVolume < AutoProfileConstants.FINAL_VOLUME_POP_UP_VALUE_THREE &&
        manualControlThreshold >= minManualControlThreshold
      ) {
        dispatch(manualControlActions.IsShowManualControlPopUp(true));
      } else {
        const bus = eventBusObject();
        bus.publish(RecoveryOfLiquidEvent.SHOW_POP_UP, {
          recoveryAction:
            manualControlThreshold >= minManualControlThreshold
              ? RecoveryOfLiquidAction.STOP_MANUAL_CONTROL
              : RecoveryOfLiquidAction.RECOVERY_FROM_STOP_AUTO,
        });
      }
    }
  };

export const handleOnStateChangeEvent =
  (data, operationMode) => (dispatch, getState) => {
    const { setupStore } = getState();
    const { currentPCState } = setupStore;

    // handle change auto profile method when running from tv/remote
    batch(() => {
      dispatch(
        updateAutoProfileSetupMode(
          AutoProfileOperationModeMethod[operationMode]
        )
      );
      dispatch(setRunningMethod(AutoProfileOperationModeMethod[operationMode]));
    });

    if (currentPCState !== data) {
      consoleDebug(`Device State Changed ${currentPCState} => ${data}`, {
        data,
        operationMode,
        setupStore,
      });
      switch (currentPCState) {
        case APPDATA.DEVICE_STATE.IDLE:
          dispatch(OnIdleStateChangeHandler(data));
          break;
        case APPDATA.DEVICE_STATE.PREPARING:
        case APPDATA.DEVICE_STATE.FILL_MEMBRANE:
        case APPDATA.DEVICE_STATE.PRIMING:
        case APPDATA.DEVICE_STATE.CONCENTRATING:
        case APPDATA.DEVICE_STATE.DIAFILTRATION:
          switch (data) {
            case APPDATA.DEVICE_STATE.IDLE:
              dispatch(updatePCState(APPDATA.DEVICE_STATE.STOPPING));
              dispatch(
                OnStopppingStateChangeHandler(APPDATA.DEVICE_STATE.IDLE)
              );
              dispatch(closeLockRunningProfileModal());
              dispatch(
                manualControlActions.IsShowManualControlAvailablePopUp(false)
              );
              dispatch(manualControlActions.IsShowManualControlPopUp(false));
              break;
            case APPDATA.DEVICE_STATE.PAUSED:
              dispatch(pauseActionHandler(operationMode));
              break;
            case APPDATA.DEVICE_STATE.DEPRESSURIZING:
              dispatch(ShowDepressurizingLoading());
              break;
            case APPDATA.DEVICE_STATE.RECOVERING:
              dispatch(ShowRecoveringLoading());
              break;
            default:
              dispatch(updatePCState(data));
              break;
          }
          break;
        case APPDATA.DEVICE_STATE.PAUSED:
          dispatch(OnPauseStateChangeHandler(data));
          break;
        case APPDATA.DEVICE_STATE.RECOVERING:
          dispatch(OnRecoveringStateChangeHandler(data));
          break;
        case APPDATA.DEVICE_STATE.DEPRESSURIZING:
          dispatch(OnDepressurizingStateChangeHandler(data, operationMode));
          break;
        case APPDATA.DEVICE_STATE.STOPPING:
          dispatch(OnStopppingStateChangeHandler(data));
          break;
        default:
          dispatch(updatePCState(data));
          break;
      }
    }
  };

export const handleManualProfileUpdatedEvent =
  (data) => (dispatch, getState) => {
    const {
      setupStore: {
        isPCRunning,
        isManualProfileRunning,
        cleaningProperties,
        defaultSequenceTemplate,
      },
    } = getState();
    const IsPCRunning =
      isPCRunning ||
      isManualProfileRunning ||
      cleaningProperties.isCleaningWizardRunning;
    if (IsPCRunning) {
      const {
        Status,
        Operations,
        Repeat,
        Repeated,
        DefaulthPrimeParam,
        Message,
      } = data;
      const UiOperations = [];
      const StatusOperations = Operations;
      const newOperations = ConvertBEOperationsToUIOperations(
        StatusOperations,
        UiOperations,
        defaultSequenceTemplate
      );
      batch(() => {
        dispatch(SetCustomOperationStatus(Status));
        dispatch(UpdateTempOperationList(Operations));
        dispatch(UpdateOperationList(newOperations));
        dispatch(SetCustomOperationRepeatValue(Repeat));
        dispatch(SetCustomOperationRepeatedValue(Repeated));
        dispatch(SetDefaultPrimeParam(DefaulthPrimeParam));
        dispatch(SetCustomOperationMessage(Message));
      });
    } else {
      const manualProfileStatus = data.Status === APPDATA.DEVICE_STATE.RUNNING;
      //   consoleLog('updatedCustomOperation', updatedCustomOperation, CustomOperation, IsPCRunning);
      if (manualProfileStatus && !isManualProfileRunning)
        dispatch(updateIsManualProfileRunning(manualProfileStatus));
    }
  };

export const handleCleaningProfileUpdatedEvent =
  (data) => (dispatch, getState) => {
    consoleLog("cleaningCustomOperation", data);
    const {
      setupStore: { isPCRunning, isManualProfileRunning, cleaningProperties },
    } = getState();
    const IsPCRunning =
      isPCRunning ||
      isManualProfileRunning ||
      cleaningProperties.isCleaningWizardRunning;
    const {
      Status,
      Operations,
      Name,
      IsDepressurizedAtTheEnd,
      Repeat,
      Repeated,
      DefaulthPrimeParam,
      Message,
      TimeElapsed,
    } = data;
    batch(() => {
      dispatch(SetCleaningCustomOperationStatus(Status));
      dispatch(UpdateCleaningOperationList(Operations));
      dispatch(SetCleaningCustomOperationName(Name));
      dispatch(
        SetCleaningCustomOperationDepressurizingAtTheEnd(
          IsDepressurizedAtTheEnd
        )
      );
      dispatch(SetCleaningCustomOperationRepeatValue(Repeat));
      dispatch(SetCleaningCustomOperationRepeatedValue(Repeated));
      dispatch(SetCleaningDefaultPrimeParam(DefaulthPrimeParam));
      dispatch(SetCleaningCustomOperationMessage(Message));
      dispatch(SetCleaningCustomOperationTimeElapsed(TimeElapsed));

      if (!IsPCRunning && Status !== APPDATA.DEVICE_STATE.IDLE)
        dispatch(setCleaningProperties({ isCleaningWizardRunning: true }));
    });
  };

export const handleOnDeviceFailureEvent = (data) => (dispatch) => {
  if (!DeviceFailureError[data.Code]) return;

  PostRequest(APPDATA.API.POST_PAUSE_PROTEIN_CONCENTRATOR).then(() => {
    const onClickStopAndRecovery = () => {
      const bus = eventBusObject();
      PostRequest(APPDATA.API.POST_STOP_PROTEIN_CONCENTRATOR, {
        StopAction: StopEnum.PAUSED,
      }).then(() => {
        dispatch(IsRecoveryFromErrorProfile(true));
        bus.publish(RecoveryOfLiquidEvent.SHOW_POP_UP, {
          recoveryAction: RecoveryOfLiquidAction.RECOVERY_FROM_STOP_ERROR,
        });
      });
      dispatch(hidePopUp());
    };

    const onClickContinue = () => {
      // const bus = eventBusObject();
      PostRequest(APPDATA.API.POST_RESUME_PROTEIN_CONCENTRATOR);
      dispatch(hidePopUp());
    };

    let stopButton = [];
    switch (data.Code) {
      case DeviceFailureError.VOLUME_SLOW_DEVICE:
      case DeviceFailureError.VOLUME_FAST_DEVICE:
      case DeviceFailureError.VOLUME_SENSOR_NOT_RESPONDING:
      case DeviceFailureError.VOLUME_CHANGES_SIGNIFICANLY:
        stopButton = [
          {
            id: APPDATA.STOP_AND_RECOVERY,
            isPrimaryButton: false,
            label: APPDATA.STOP_AND_RECOVERY,
            onClick: onClickStopAndRecovery,
            className: "secondaryRedButton",
          },
        ];
        break;
      case DeviceFailureError.VOLUME_SENSOR_TUBE_NOT_AVAILABLE:
        stopButton = [
          {
            id: APPDATA.CONTINUE,
            isPrimaryButton: true,
            label: APPDATA.CONTINUE,
            onClick: onClickContinue,
            className: "green-button",
          },
          {
            id: APPDATA.STOP_AND_RECOVERY,
            isPrimaryButton: false,
            label: APPDATA.STOP_AND_RECOVERY,
            onClick: onClickStopAndRecovery,
            className: "secondaryRedButton",
          },
        ];
        break;
      default:
        break;
    }

    dispatch(
      showPopUp({
        popUpTitle:
          data?.Device ||
          formatMessage({ id: `modal.${enumToCamelCase(data.Code)}.title` }),
        popUpText:
          data?.Message ||
          formatMessage({ id: `modal.${enumToCamelCase(data.Code)}.message` }), // APPDATA.ERROR_DICTIONARY.ERRORS[data.Code].MESSAGE,
        popUpQuestion: undefined,
        popUpButton: stopButton,
        popUpHideCloseButton: true,
      })
    );
  });
};

export const handleOnDelayProfilePreparationEvent = () => (dispatch) => {
  batch(() => {
    dispatch(
      showAlert({
        alertShow: true,
        alertText: formatMessage({ id: "toast.schedulerProfile.oneMinute" }),
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
      })
    );
    dispatch(setScheduleWillRun(true));
    dispatch(hideScheduleRunModal(true));
    goToAutoSetupScreen();
  });
};

export const handleOnDelayProfileStartEvent = (data) => (dispatch) => {
  batch(() => {
    dispatch(postHighVolumeBuffer());
    dispatch(validateAutoProfileScheduledParams(data));
    dispatch(showAlert({ alertShow: false }));
    dispatch(resetScheduler());
  });
};

export const handleOnRecoveryStatusUpdatedEvent =
  (data) => (dispatch, getState) => {
    const { setupStore } = getState();
    const { recoveryOfLiquidStatus } = setupStore;
    consoleLog("updateRecoveryStatus", recoveryOfLiquidStatus, data);
    dispatch(updateRecoveryStatus(data));
    dispatch(handleRecoveryStatusUpdate(data));
    console.log("DATA  buffer", data);
  };

export const handleOnAutoProfileUpdatedEvent =
  (data) => async (dispatch, getState) => {
    const {
      setupStore: {
        isPCRunning,
        activeMenu,
        percentageProgressBar,
        profileRunning,
        currentAdvSetupParams,
      },
    } = getState();

    const { Config } = profileRunning;
    const { AdvancedSetupName } = Config || {};
    const { Name } = currentAdvSetupParams || {};

    const percentage = isPCRunning ? data[APPDATA.KEY.PercentageComplate] : 0;
    const estimateTimeInSeconds = data[APPDATA.KEY.EstSecondRemaining];
    const newStatus = getAutoProfileUpdateStatusModel(data);
    const autoProfileMode = getAutoProfileModeOnRunningProfile(
      data.profileRunning.Config.DiafiltrationMode,
      data.profileRunning.Config.MoreThan50ml
    );

    if (AdvancedSetupName && Name && AdvancedSetupName !== Name) {
      const selectedAdvSetup = await getSelectedAdvSetupsApi(
        data?.profileRunning?.Config?.IdAdvancedSetup
      );
      dispatch(updateCurrentAdvSetupParam(selectedAdvSetup?.data));
    }
    batch(() => {
      dispatch(
        updateCurrentIsMoreThan50ml(data.profileRunning.Config.MoreThan50ml)
      );
      dispatch(updateStatus(newStatus));
      dispatch(updateAutoProfileSetupMode(autoProfileMode));
      dispatch(setRunningMethod(autoProfileMode));

      if (percentageProgressBar !== percentage)
        dispatch(updatePercentageProgressBar(percentage));

      dispatch(setEstimateTime(estimateTimeInSeconds));
    });

    if (data[APPDATA.KEY.DeviceStatus] !== APPDATA.DEVICE_STATE.IDLE) {
      const { currentRunningMode } = data;
      switch (currentRunningMode) {
        case APPDATA.ENUM.CURRENT_RUNNING_MODE.AUTO_PROFILE:
          if (
            !(
              activeMenu === APPDATA.SETUP ||
              activeMenu === APPDATA.STATUS ||
              activeMenu === APPDATA.AUTO_PROFILE_SETUP_TAB ||
              activeMenu === APPDATA.AUTO_PROFILE_STATUS_TAB ||
              activeMenu === APPDATA.VOLUME_SENSOR_CHART ||
              activeMenu === APPDATA.AUTO_PROFILE_PARAMETERS_TAB
            )
          ) {
            window.location.href = APPDATA.AUTO_PROFILE_STATUS;
          }
          break;

        case APPDATA.ENUM.CURRENT_RUNNING_MODE.MANUAL_PROFILE:
          if (activeMenu !== APPDATA.MANUAL_PROFILE) {
            window.location.href = APPDATA.MANUAL_PROFILE_ADDRESS;
          }
          break;

        case APPDATA.ENUM.CURRENT_RUNNING_MODE.CLEANING_WIZARD:
          if (activeMenu !== APPDATA.CLEANING_WIZARD) {
            window.location.href = APPDATA.CLEANING_WIZARD_ADDRESS;
          }
          break;
        default:
          break;
      }
    }

    dispatch(SetCycleFinishStatus(data.isCycleFinish));

    GetPCLocked(data[APPDATA.KEY.Locked]);
  };

export const handleOnCycleTimesUpdatedEvent = (data) => () => {
  console.log({ data });
};

export const handleOnManualControlStatusUpdatedEvent =
  (data) => (dispatch, getState) => {
    const {
      manualControlStore: { StatusManualControl },
    } = getState();
    const newStatusManualControl = data;
    const previouseStatusManualControl = { ...StatusManualControl };

    if (!isEqual(newStatusManualControl, previouseStatusManualControl)) {
      batch(() => {
        dispatch(setStatusManualControl(newStatusManualControl));
        dispatch(
          checkIsManualControlEnable(
            newStatusManualControl,
            previouseStatusManualControl
          )
        );
      });
    }
  };

export const handleOnDiafiltrationStatusUpdatedEvent = (data) => (dispatch) => {
  dispatch(handleRefillBufferVolumeOnEvent(data));
};

export const handleOnVolumeThresholdErrorEvent = (data) => (dispatch) => {
  const newErrorParams = data;
  if (newErrorParams !== null) {
    switch (newErrorParams.Code) {
      case APPDATA.ERROR_DICTIONARY.VolumeThreshold:
        dispatch(SetErrorParams(newErrorParams));
        dispatch(updateShowThresholdError(true));
        break;
      default:
        break;
    }
  }
};

export const handleOnLicenseExpiredEvent = (data) => (dispatch) => {
  dispatch(deviceInfoActions.updateLicenseInfo(data));
  dispatch(hideScheduleRunModal());

  const onClickButtonDemoModal = () => {
    const bus = eventBusObject();
    dispatch(hidePopUp());
    window.location.href = APPDATA.INFO_AND_SUPPORT_ADDRESS;
    dispatch(
      deviceInfoActions.updateLicenseActivationMode(
        APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE
      )
    );
    bus.publish(EventLicenseService.LicenseModalService, {
      licenseMode: APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE,
    });
  };

  const activateButton = [
    {
      id: APPDATA.ACTIVATE,
      label: APPDATA.ACTIVATE,
      isPrimaryButton: true,
      onClick: onClickButtonDemoModal,
    },
  ];

  if (data.LicenseType !== APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT) {
    dispatch(
      showPopUp({
        popUpTitle: APPDATA.MESSAGES.LICENSE.MODAL_DEMO.TITLE,
        popUpText: APPDATA.MESSAGES.LICENSE.MODAL_DEMO.TEXT,
        popUpButton: activateButton,
        popUpHideCloseButton: true,
      })
    );
  }
};

export const setDeviceHubConnection = (state) => (dispatch) => {
  dispatch(setDeviceHubConnectionState(state));
};

export const handleOnDeviceLockUpdated = (data) => (dispatch) => {
  dispatch(updateLockAccess(data.Locked));
};
